import React from 'react';

export const SvgThumbsUp = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.63816 11.35L11.2381 5.5C11.7553 5.5 12.2513 5.70544 12.617 6.07114C12.9827 6.43683 13.1881 6.93282 13.1881 7.44999V10.05H16.8671C17.0555 10.0478 17.2422 10.0867 17.4141 10.1639C17.5861 10.241 17.7392 10.3546 17.8628 10.4969C17.9865 10.6391 18.0777 10.8064 18.1303 10.9874C18.1828 11.1684 18.1954 11.3586 18.1671 11.545L17.2701 17.3949C17.2231 17.7049 17.0656 17.9875 16.8267 18.1905C16.5879 18.3936 16.2836 18.5035 15.9701 18.4999H8.63816M8.63816 11.35V18.4999M8.63816 11.35H6.68818C6.3434 11.35 6.01274 11.4869 5.76894 11.7307C5.52515 11.9745 5.38818 12.3052 5.38818 12.65V17.1999C5.38818 17.5447 5.52515 17.8754 5.76894 18.1192C6.01274 18.363 6.3434 18.4999 6.68818 18.4999H8.63816"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
